import { CustomerCompanyMessage } from '../../../../../types/CustomerCompanyMessage';
import { useRole } from '../../../../common/hooks/useRole';
import { GeneralInformation } from '../../../GeneralInformation';
import { useCustomerDetailsEdit } from '../useCustomerDetailsEdit';

import { CustomerAssignmentsSection } from './CustomerAssignmentsSection';

interface CustomerDetailsTabProps {
    customer: CustomerCompanyMessage;
}

export const CustomerDetailsTab = ({ customer }: CustomerDetailsTabProps) => {
    const role = useRole();
    const editCustomerDetailsMutation = useCustomerDetailsEdit();
    const showAssignments = role.isSuperAdmin() || role.hasAdminRights(customer.id);

    const onEditSubmit = async (data: CustomerCompanyMessage) => {
        await editCustomerDetailsMutation.mutateAsync({ id: customer.id, customerData: data });
    };

    return (
        <>
            <GeneralInformation onEditSubmit={onEditSubmit} companyDetails={customer} />
            {showAssignments ? <CustomerAssignmentsSection customerId={customer.id} /> : null}
        </>
    );
};
